var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inp-subtle",
    staticStyle: {
      "white-space": "pre-wrap",
      "font-family": "consolas, monospace"
    }
  }, [_c('span', {
    staticClass: "inp-subtle-span",
    class: {
      'input-raw--invalid': _vm.invalid
    },
    domProps: {
      "textContent": _vm._s((_vm.invalid || _vm.model || _vm.placeholder) + '.')
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "ta",
    staticClass: "input",
    attrs: {
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.input,
      "change": _vm.change
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e45e6486","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputRaw.vue
// module id = 54
// module chunks = 1